module.exports = __webpack_public_path__ + "img/ok-circle.3552e630.svg";